import React, { memo, useCallback, useMemo } from "react";
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image";

const BREAKPOINTS = {
  FULL: [
    { key: "mob", media: "(max-width: 767px)" },
    { key: "mid", media: "(min-width: 768px) and (max-width: 991px)" },
    { key: "smallDesk", media: "(min-width: 992px) and (max-width: 1199px)" },
    { key: "midDesk", media: "(min-width: 1200px) and (max-width: 1365px)" },
  ],
  BASIC: [
    { key: "mob", media: "(max-width: 767px)" },
    { key: "mid", media: "(min-width: 768px) and (max-width: 1199px)" },
  ],
};

const FastGatsbyImage = ({
  imageData,
  imageAltName = "banner",
  isFullBreaks,
  isAdaptive,
  imageClassName = "",
  wrapImageClassName = "",
}) => {
  const isRetina = typeof window !== "undefined" && window.devicePixelRatio > 1;
  const images = useMemo(() => {
    const result = {};
    for (const key in imageData) {
      if (imageData[key]) {
        result[key] = getImage(imageData[key]);
      }
    }
    return result;
  }, [imageData]);

  const getImageForDPR = useCallback(
    (baseKey) => {
      const hdKey = `${baseKey}2x`;
      return isRetina && images[hdKey] ? images[hdKey] : images[baseKey];
    },
    [images, isRetina]
  );

  const image = useMemo(() => {
    const baseImage = getImageForDPR("default");

    if (!isAdaptive) return baseImage;

    const breakpoints = isFullBreaks ? BREAKPOINTS.FULL : BREAKPOINTS.BASIC;
    const artDirected = breakpoints.map(({ key, media }) => ({
      media,
      image: getImageForDPR(key),
    }));

    return withArtDirection(baseImage, artDirected);
  }, [isAdaptive, isFullBreaks, getImageForDPR]);

  return (
    <GatsbyImage
      image={image}
      alt={imageAltName}
      imgClassName={imageClassName}
      className={wrapImageClassName}
      loading="eager"
    />
  );
};

export default memo(FastGatsbyImage);
